import React from "react";
import { nonNullable, takeFirst } from "~/features/app/utils";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { Tag } from "~/features/ui/tag";

const fragment = graphql(`
  fragment ArticleMetaDataTags on article_default_Entry {
    category: articleCategory {
      ... on articleCategory_Category {
        id
        title
        slug
      }
    }
    industry: industry {
      ... on industryCategory_Category {
        id
        title
        slug
      }
    }
  }
`);

type Props = FragmentType<typeof fragment> & {
  tagVariant?: React.ComponentProps<typeof Tag>["variant"];
};

export function ArticleTags(props: Props) {
  const { tagVariant, ...rest } = props;
  const { industry, category } = useFragment(fragment, rest as FragmentType<typeof fragment>);

  const items = [takeFirst(category), takeFirst(industry)].filter(nonNullable);

  return (
    <ul tw="flex gap-4 z-10 relative">
      {items.map((item) => (
        <Tag as="li" key={item.id} variant={tagVariant}>
          {item.title}
        </Tag>
      ))}
    </ul>
  );
}
